import { useState } from 'react';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import '../Dynamic/Collapsible.scss';

export function Collapsible({ title, children }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="collapsible-refinement">
      <div
        className={`collapsible-header d-flex justify-content-between align-items-center px-3 py-2 ${isOpen && 'show'}`}
        onClick={() => setIsOpen(!isOpen)}
        style={{ cursor: 'pointer' }}
      >
        <span className="title">{title}</span>
        <span>{isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}</span>
      </div>

      <div className={`collapsible-body px-3 ${isOpen ? 'open' : 'closed'}`}>
        {children}
      </div>
    </div>
  );
}
